import Domain from 'enums/Domain'
import WidgetType from 'enums/WidgetType'
import { Metadata } from '../../adaptor/metadata'
import domainResolver from '../document/domainResolver'
import displayTextRangeResolver from './displayTextRangeResolver'
import originalAuthorResolver from '../originalAuthor/originalAuthorResolver'
import postTypeResolver from '../document/postTypeResolver'
import { removeMetaData } from './retweetsUtil'

export const resolveReplyToAuthors = (displayText: string, metadata: Metadata) => {
  if (
    metadata.getWidgetType() === WidgetType.SOCIAL_WEB_POPULAR_POSTS ||
    metadata.getWidgetType() === WidgetType.SOCIAL_WEB_POPULAR_LINKS ||
    metadata.getWidgetType() === WidgetType.AUDIENCE_POPULAR_LINKS
  ) {
    return [] as string[]
  }

  const { domain } = domainResolver(metadata)
  const { displayTextRange } = displayTextRangeResolver(metadata)
  const { originalAuthor } = originalAuthorResolver(metadata)
  const { postType } = postTypeResolver(metadata)

  if (
    domain === Domain.TWITTER &&
    displayTextRange &&
    displayTextRange[0] &&
    displayTextRange[0].startOffset! > 0
  ) {
    return removeMetaData(displayText!, originalAuthor!, postType!)
      .substring(0, displayTextRange[0].startOffset! - 1)
      .split(' ')
  }

  return undefined
}

export default resolveReplyToAuthors
